import React from 'react';
import './IconButton.scss';

const iconClassMap: Record<string, string> = {
  tag: 'fa-regular fa-lg fa-tag',
  menu: 'fa-regular fa-lg fa-ellipsis-vertical',
  filter: 'fa-regular fa-lg fa-filter',
  question: 'fa-sharp fa-regular fa-lg fa-circle-question',
  close: 'fa-solid fa-lg fa-xmark',
  checkmark: 'fa-solid fa-lg fa-check',
  message: 'fa-regular fa-lg fa-message',
  eye: 'fa-regular fa-lg fa-eye',
  expand: 'fa-regular fa-lg fa-arrow-up-right-and-arrow-down-left-from-center',
  addCircle: 'fa-regular fa-lg fa-plus',
  add: 'fa-solid fa-lg fa-plus',
  edit: 'fa-regular fa-lg fa-pen-to-square',
  chevronDown: 'fa-regular fa-lg fa-caret-down',
};

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: keyof typeof iconClassMap;
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  variant?: 'default' | 'transparent';
  style?: React.CSSProperties;
}

export const IconButton: React.FC<IconButtonProps> = ({ icon, onMouseDown, variant = 'default', className, style, ...props }) => {
  const iconClass = iconClassMap[icon] || '';

  return (
    <button className={`icon-button icon-button__${variant} ${className || ''}`} onMouseDown={onMouseDown} aria-label={icon} {...props} style={style}>
      <i className={iconClass} />
    </button>
  );
};
